<script setup lang="ts">
import type { DropdownMenuItem } from "@nuxt/ui"

import { UtilsJsonview } from "#components"
const LangsStore = useLangsStore()

const UserStore = useUserStore()
defineProps<{
	collapsed?: boolean
}>()
const open = defineModel() as unknown

// const user = ref({
// 	name: 'Dexterial',
// 	avatar: {
// 		src: 'https://github.com/dexterial.png',
// 		alt: 'Dexterial',
// 	},
// })

// const users = await getCurrentUser()

const role_view = computed<DropdownMenuItem[][]>(() => [
	{
		label: LangsStore.getLangEntry("base_langs", "global-admin"),
		id: "global_admin",
		avatar: { src: "/logo_mic.png" },
		defaultOpen: true,
		children: [
			{
				label: LangsStore.getLangEntry("base_langs", "global-admin-users-viewer"),
				id: "global_admin_users_viewer",

				to: "/" + LangsStore.context.lang_id + "/users/viewer",
				icon: "i-lucide-settings",
				exact: true,
				onSelect: () => {
					open.value = false
				},
			},
		],
	},
])
const role_edit = computed<DropdownMenuItem[][]>(() => {
	return [
		{
			label: LangsStore.getLangEntry("base_langs", "dextools-utilities"),
			id: "qrs-utilities",

			icon: "i-lucide-circuit-board",
			defaultOpen: true,
			children: [
				{
					label: LangsStore.getLangEntry("base_langs", "dextools-utilities-langs"),
					id: "dextools-utilities-langs",
					icon: "i-lucide-type-outline",
					to: "/" + LangsStore.context.lang_id + "/admin/utilities/langs",
					// badge: '4',
					onSelect: () => {
						//getSetQPar(FigmaStore.context, 'state', 'figma_reader_files')
						open.value = false
					},
				},
				{
					label: LangsStore.getLangEntry("base_langs", "dextools-utilities-files"),
					id: "dextools-utilities-files",
					icon: "i-lucide-files",
					to: "/" + LangsStore.context.lang_id + "/admin/utilities/files",
					// badge: '4',
					onSelect: () => {
						//getSetQPar(FigmaStore.context, 'state', 'figma_reader_files')
						open.value = false
					},
				},
				{
					label: LangsStore.getLangEntry("base_langs", "dextools-utilities-sheets"),
					id: "dextools-utilities-sheets",
					icon: "i-lucide-database-backup",
					to: "/" + LangsStore.context.lang_id + "/admin/utilities/sheets",
					// badge: '4',
					onSelect: () => {
						//getSetQPar(FigmaStore.context, 'state', 'figma_reader_files')
						open.value = false
					},
				},
				{
					label: LangsStore.getLangEntry("base_langs", "dextools-utilities-excels"),
					id: "dextools-utilities-excels",
					icon: "i-lucide-file-spreadsheet",
					to: "/" + LangsStore.context.lang_id + "/admin/utilities/excels",
					// badge: '4',
					onSelect: () => {
						//getSetQPar(FigmaStore.context, 'state', 'figma_reader_files')
						open.value = false
					},
				},
				{
					label: LangsStore.getLangEntry("base_langs", "dextools-utilities-stripe"),
					id: "dextools-utilities-stripe",
					icon: "i-lucide-calculator",
					to: "/" + LangsStore.context.lang_id + "/admin/utilities/stripe",
					// badge: '4',
					onSelect: () => {
						//getSetQPar(FigmaStore.context, 'state', 'figma_reader_files')
						open.value = false
					},
				},
			],
		},
		{
			label: LangsStore.getLangEntry("base_langs", "global-admin"),
			id: "global_admin",
			avatar: { src: "/logo_mic.png" },
			defaultOpen: true,
			children: [
				{
					label: LangsStore.getLangEntry("base_langs", "global-admin-subscriptions"),
					id: "global-admin-subscriptions",
					to: "/" + LangsStore.context.lang_id + "/admin/subscriptions",
					icon: "i-lucide-settings",
					exact: true,
					onSelect: () => {
						open.value = false
					},
				},

				{
					label: LangsStore.getLangEntry("base_langs", "global-admin-companies"),
					id: "global-admin-companies",
					to: "/" + LangsStore.context.lang_id + "/admin/companies",
					icon: "i-lucide-settings",
					exact: true,
					onSelect: () => {
						open.value = false
					},
				},
				{
					label: LangsStore.getLangEntry("base_langs", "global-admin-templates"),
					id: "qrsapp_application_templates_emails",
					to: "/" + LangsStore.context.lang_id + "/admin/templates/emails",
					icon: "i-lucide-settings",
					exact: true,
					onSelect: () => {
						open.value = false
					},
				},
				{
					label: LangsStore.getLangEntry("base_langs", "global-admin-users-editor"),
					id: "global-admin-users-editor",

					to: "/" + LangsStore.context.lang_id + "/admin/users/editor",
					icon: "i-lucide-settings",
					exact: true,
					onSelect: () => {
						open.value = false
					},
				},

				{
					label: LangsStore.getLangEntry("base_langs", "global-admin-playground"),
					id: "global-admin-playground",

					to: "/" + LangsStore.context.lang_id + "/admin/playground/tests",
					icon: "i-lucide-play",
					exact: true,
					onSelect: () => {
						open.value = false
					},
				},
			],
		},
		{
			label: LangsStore.getLangEntry("base_langs", "global-admin-data"),
			id: "global-admin-data",
			avatar: { src: "/logo_mic.png" },
			defaultOpen: true,
			children: [
				{
					label: LangsStore.getLangEntry("base_langs", "global-admin-table-users"),
					id: "global-admin-data-users",
					to: "/" + LangsStore.context.lang_id + "/admin/data/users",
					icon: "i-lucide-settings",
					exact: true,
					onSelect: () => {
						open.value = false
					},
				},
				{
					label: LangsStore.getLangEntry("base_langs", "global-admin-table-companies"),
					id: "global-admin-data-companies",
					to: "/" + LangsStore.context.lang_id + "/admin/data/companies",
					icon: "i-lucide-settings",
					exact: true,
					onSelect: () => {
						open.value = false
					},
				},
				{
					label: LangsStore.getLangEntry("base_langs", "global-admin-table-subscriptions"),
					id: "global-admin-data-subscriptions",
					to: "/" + LangsStore.context.lang_id + "/admin/data/subscriptions",
					icon: "i-lucide-settings",
					exact: true,
					onSelect: () => {
						open.value = false
					},
				},
				{
					label: LangsStore.getLangEntry("base_langs", "global-admin-table-templates"),
					id: "global-admin-data-templates",
					to: "/" + LangsStore.context.lang_id + "/admin/data/templates",
					icon: "i-lucide-settings",
					exact: true,
					onSelect: () => {
						open.value = false
					},
				},
			],
		},
		{
			label: LangsStore.getLangEntry("base_langs", "global-links"),
			id: "global_links",
			defaultOpen: true,
			children: [
				{
					// label: 'Feedback',
					label: LangsStore.getLangEntry("base_langs", "link-nuxt-ui"),
					id: "link-nuxt-ui-prime",
					icon: "i-lucide-message-circle",
					to: "https://ui4.nuxt.com/docs/components",
					target: "_blank",
				},
				{
					// label: 'Feedback',
					label: LangsStore.getLangEntry("base_langs", "link-lucide-icons"),
					id: "link-lucide-icons",
					icon: "i-lucide-message-circle",
					to: "https://lucide.dev/icons/",
					target: "_blank",
				},

				{
					// label: 'Help & Support',
					label: LangsStore.getLangEntry("base_langs", "link-nuxt-pro"),
					id: "link-nuxt-pro",
					icon: "i-lucide-info",
					to: "https://github.com/nuxt",
					target: "_blank",
				},

				{
					// label: 'Help & Support',
					label: LangsStore.getLangEntry("base_langs", "link-tanstack"),
					id: "link-tanstack",
					icon: "i-lucide-table",
					to: "https://tanstack.com/table/latest/docs/introduction",
					target: "_blank",
				},
			],
		},
	]
})
</script>

<template>
	<!-- {{ UserStore.user_full.auth }} -->
	<!-- {{ UserStore.user_full?.auth?.photoURL }} -->

	<UNavigationMenu
		:collapsed="collapsed"
		:items="
			UserStore.user_full?.roles?.app == 'reader'
				? role_view
				: UserStore.user_full?.roles?.app == 'editor'
					? role_edit
					: []
		"
		orientation="vertical"
	/>
</template>
